import _typeof from '@babel/runtime/helpers/typeof';
import classnames from 'classnames';
import React__default from 'react';
import SelectionCell from '../RowSelection/SelectionCell.js';
import { useTable } from '../utils/hooks.js';

/**
 * Row - Individual Row
 * @param {object} props
 * @param {{ field: string }} props.singleRowData single row of data
 * @param {string} props.classesForColumns css classes usually used for spacing and text alignment
 * @param {string} props.id unique identifier
 * @param {number} props.parentRowGroupIndex the index of the column def row group
 * @param {{ field: {style: value} }} props.stylesForColumns object of styles
 * @returns {any}
 */

function Row(_ref) {
  var singleRowData = _ref.singleRowData,
    classesForColumns = _ref.classesForColumns,
    id = _ref.id,
    parentRowGroupIndex = _ref.parentRowGroupIndex,
    stylesForColumns = _ref.stylesForColumns;
  var _useTable = useTable(),
    _useTable$state = _useTable.state,
    columns = _useTable$state.columns,
    dataTestId = _useTable$state.dataTestId,
    groupDisplayType = _useTable$state.groupDisplayType,
    name = _useTable$state.name,
    onRowSelect = _useTable$state.onRowSelect,
    rowSelection = _useTable$state.rowSelection,
    showGrid = _useTable$state.showGrid,
    selectedRows = _useTable$state.selectedRows;
  var colSpan = groupDisplayType === 'multipleColumns' ? parentRowGroupIndex + 1 : null;
  var columnOrder = columns.columnDefs.filter(function (column) {
    return !column.rowGroup;
  });
  var classesForAllBodyCell = classnames('C-TableAdvanced__bodyCell', {
    '--showGrid': showGrid
  });
  return /*#__PURE__*/React__default.createElement("tr", {
    className: "C-TableAdvanced__bodyRow",
    key: id,
    "data-testid": "".concat(dataTestId, "-").concat(id)
  }, rowSelection && /*#__PURE__*/React__default.createElement(SelectionCell, {
    dataTestId: dataTestId,
    onRowSelect: onRowSelect,
    rowId: singleRowData.id,
    singleRowData: singleRowData,
    rowSelection: rowSelection,
    selectedRows: selectedRows,
    parentRowGroupIndex: parentRowGroupIndex,
    showGrid: showGrid,
    tableName: name,
    pinned: columns.columnDefs.some(function (_ref2) {
      var pinned = _ref2.pinned;
      return pinned;
    })
  }), columns.hasRowGroup && /*#__PURE__*/React__default.createElement("td", {
    className: classesForAllBodyCell,
    key: "empty",
    "data-testid": "".concat(dataTestId, "-cell-0"),
    colSpan: colSpan
  }), columnOrder.map(function (column, index) {
    var field = column.field;
    var testId = "".concat(dataTestId, "-cell-").concat(columns.hasRowGroup ? index + 1 : index);
    var classesForBodyCell = classnames(classesForAllBodyCell, classesForColumns === null || classesForColumns === void 0 ? void 0 : classesForColumns[field]);
    var stylesForBodyCell = stylesForColumns === null || stylesForColumns === void 0 ? void 0 : stylesForColumns[field];
    if (singleRowData[field] !== undefined) {
      if (_typeof(singleRowData[field]) === ('date' )) {
        console.error('Hey Canvas User, looks like you passed a special data type as a field value. Please pass a cell object with `cellDisplay` and `cellValue` attributes instead.');
      }
      if (_typeof(singleRowData[field]) === 'object') {
        var _singleRowData$field, _singleRowData$field2;
        return /*#__PURE__*/React__default.createElement("td", {
          "data-testid": testId,
          "data-value": String((_singleRowData$field = singleRowData[field]) === null || _singleRowData$field === void 0 ? void 0 : _singleRowData$field.cellValue),
          className: classesForBodyCell,
          style: stylesForBodyCell,
          key: "".concat(field, "-data")
        }, (_singleRowData$field2 = singleRowData[field]) === null || _singleRowData$field2 === void 0 ? void 0 : _singleRowData$field2.cellDisplay);
      } else {
        return /*#__PURE__*/React__default.createElement("td", {
          className: classesForBodyCell,
          style: stylesForBodyCell,
          "data-testid": testId,
          role: column.isRowHeader ? 'rowheader' : null,
          key: "".concat(field, "-data")
        }, singleRowData[field]);
      }
    } else {
      return /*#__PURE__*/React__default.createElement("td", {
        className: classesForBodyCell,
        style: stylesForBodyCell,
        "data-testid": testId,
        key: "".concat(field, "-data")
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "hc-sr-only",
        "aria-label": "empty cell"
      }, "N/A"));
    }
  }));
}

export { Row as default };
